import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableModule
} from "@angular/material/table";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {MatButtonModule, MatMiniFabButton} from "@angular/material/button";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatRipple, MatRippleModule} from "@angular/material/core";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatTooltip, MatTooltipModule} from "@angular/material/tooltip";
import {NgOptimizedImage} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {TableElement, TableExportUtil, UnsubscribeOnDestroyAdapter} from "@shared";
import {PrescriptionService} from "@core/http/table-data-services/prescription.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {AuthManagementService} from "@core/service/auth-management.service";
import {CatalogsService} from "@core/http/catalogs.service";
import {Router} from "@angular/router";
import {Prescription} from "@core/models/Prescription";
import {fromEvent} from "rxjs";
import {UserRole} from "@core/models/Enums/UserRole";
import {FilterRecetaDoctor} from "@core/models/FilterRecetaDoctor";
import {PrescriptionbyIdDoctorDataSource} from "@core/data-source/PrescriptionbyIdDoctorDataSource";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {downloadPrescriptionPdf, generatePrescriptionPdfBase64, openPrintWindow} from "@shared/utils/window.utils";

@Component({
  selector: 'app-prescription-by-id-doctor',
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatTooltip,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    MatRipple,
    MatSort,
    MatDatepickerModule,
    MatPaginator,
    MatMiniFabButton,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgOptimizedImage,
    FeatherIconsComponent
  ],
  templateUrl: './prescription-by-id-doctor.component.html',
  styleUrl: './prescription-by-id-doctor.component.scss'
})
export class PrescriptionByIdDoctorComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {

  displayedColumns = [
    'folio',
    'medico',
    'gemp',
    'creacion',
    'status',
    'detalles',
    'descargar'
  ];

  data?: PrescriptionService;
  dataSource!: PrescriptionbyIdDoctorDataSource;
  index?: number;
  isAdmin: boolean;
  filterReceta: FilterRecetaDoctor;

  @ViewChild(MatPaginator, {static: true})
  paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true})
  sort!: MatSort;
  @ViewChild('filter', {static: true}) filter?: ElementRef;
  @Input() idDoctor!: string | null;
  @Input() idSucursal!: string | null;
  protected readonly UserRole = UserRole;

  constructor(
    public httpClient: HttpClient,
    public dialog: MatDialog,
    private authManagement: AuthManagementService,
    private catalogsService: CatalogsService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private httpMsgHandler: HttpMesageHandlerService,
    private prescriptionApi: PrescriptionService
  ) {
    super();
    this.isAdmin = this.authManagement.isUserAdmin();
    this.filterReceta = new FilterRecetaDoctor({} as FilterRecetaDoctor)
  }

  ngAfterViewInit() {
    this.filterReceta = {
      idSucursal: this.idSucursal,
      idMedico: this.idDoctor
    }
    this.loadData(this.filterReceta)
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.ngAfterViewInit();
  }

  refresh() {
    this.ngOnInit();
  }

  exportExcel() {
    const exportData: Partial<TableElement>[] =
      this.dataSource.filteredData.map((x: Prescription) => ({
        ID: x.idReceta,
      }));
    TableExportUtil.exportToExcel(exportData, 'excel');
  }

  public loadData(filterReceta: FilterRecetaDoctor) {
    this.data = new PrescriptionService(this.httpClient, this.httpMsgHandler);
    this.dataSource = new PrescriptionbyIdDoctorDataSource(
      this.data,
      this.paginator,
      this.sort,
      filterReceta,
    );
    this.subs.sink = fromEvent(this.filter?.nativeElement, 'keyup').subscribe(
      () => {
        if (!this.dataSource) {
          return;
        }
        this.dataSource.filter = this.filter?.nativeElement.value;
      }
    );
  }

  descargarPDF(row: Prescription) {
    const {idReceta, idPaciente} = row;

    this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente).subscribe({
      next: (res: string) => {
        void downloadPrescriptionPdf(res, `receta-${row.folio || idReceta}.pdf`);
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  enviarRecetaPorCorreo(row: Prescription): void {
    const { idReceta, idPaciente } = row;

    this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente).subscribe({
      next: async (res: string) => {
        try {
          const pdfBase64 = await generatePrescriptionPdfBase64(res, {
            title: 'Enviando receta...',
            subtitle: 'Estamos preparando el PDF para correo'
          });

          this.prescriptionApi.enviarRecetaPorCorreo({ idReceta, pdfBase64 }).subscribe({
            next: (response) => this.httpMsgHandler.handleMsg(response as any),
            error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
          });
        } catch (error) {
          this.httpMsgHandler.handleMsg(error as HttpErrorResponse);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  printHtml(fullHtmlString: string): void {
    const printWidth = 1000;
    const printHeight = 800;

    const screenWidth = window.screen.width || 1920;
    const screenHeight = window.screen.height || 1080;

    const left = Math.max((screenWidth - printWidth) / 2, 0);
    const top = Math.max((screenHeight - printHeight) / 2, 0);

    const features = [
      `width=${printWidth}`,
      `height=${printHeight}`,
      `top=${top}`,
      `left=${left}`,
      'resizable=yes',
      'scrollbars=yes'
    ].join(',');

    const printWindow = openPrintWindow(features);

    if (!printWindow) {
      return;
    }

    try {
      // Corta la relacion con la ventana padre para reducir riesgo de opener
      printWindow.opener = null;

      printWindow.document.open();
      printWindow.document.write(fullHtmlString);
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
    } catch (error) {
      printWindow.close();
    }
  }

  goToDetails(row: Prescription) {
    const idCodificado = btoa(row.idReceta);
    const fechaCodificada = btoa(row.fechaCreacion);
    const status = btoa(row.estatusReceta);
    this.router.navigate(['prescription/details/' + idCodificado + '/' + fechaCodificada + '/' + status]).then();
  }

}
